import script from "./batchFinanceSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./batchFinanceSupplier.vue?vue&type=script&setup=true&lang=js"

import "./batchFinanceSupplier.vue?vue&type=style&index=0&id=fc18b2b4&scoped=true&lang=css"

import exportComponent from "/Users/lock/vuework/yaojing-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc18b2b4"]])

export default __exports__